/**
 * Client-side admin check (cosmetic only — every /api/admin/* endpoint
 * enforces the allowlist server-side and returns 403 otherwise).
 */
export function adminEmails() {
  const raw = import.meta.env.VITE_ADMIN_EMAILS || 'david@zapt.ai';
  return raw.split(',').map((e) => e.trim().toLowerCase()).filter(Boolean);
}

export function isAdminEmail(email) {
  return adminEmails().includes(String(email || '').toLowerCase());
}
